<template>
  <div>
    <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          rankmapSetDetailsList: this.rankmapSetDetailsList,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData= $event"
        v-on:save="saveHandler"
        
        v-on:error="errorHandler"
      />
      <!-- v-on:cancel="cancelHandler" -->
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>

      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RankMapSetForm from "../../../components/performance/rankmapset/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": RankMapSetForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      pageTitle: this.$t('Setuprankmapset.editrankmapset'),
      pageTitleValue: "",
      formData: {
        rankmapset: null,
        description: null,
        disable: false,
        weightedavg: false,
        remark: null,
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      rankmapSetDetailsList: [],

      errMsg: "",
      isErr: false,
      loading: true,
      editMode: true,
      isConfirm: false,
    };
  },

  methods: {

    errorHandler($event) {
    this.isErr = $event.isErr;
    this.errMsg = $event.errMsg;
    },

    async loadRankMapSetHandler() {
      const vm = this;

      try {
        const res = await this.$store.dispatch('get', {url: "/rankmapset/" + vm.id});
        vm.formData = res.data.rec[0];
        vm.pageTitleValue = res.data.rec[0].rankmapset;
      } catch (err) {
        vm.isErr = !vm.isErr;
        vm.errMsg = err;
      }
    },

    async loadRankMapDetailsHandler() {
      const vm = this;

      try {
        const res = await this.$store.dispatch('get', {url: "/rankmapsetdetails/" + this.id});
        vm.rankmapSetDetailsList = res.data.rec.map(item => {
              return {
                ...item,
                isLastText: item.isLast === 1 ? 'Yes' : 'No',
                isMedianText: item.isMedian === 1 ? 'Yes' : 'No',
              };
            });
      } catch (err) {
        vm.isErr = !vm.isErr;
        vm.errMsg = err;
      }
    },


    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      this.$store.dispatch('put', {url: "/rankmapset/" + vm.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "rankmapsetlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
  },

  async mounted() {
    Promise.all([await this.loadRankMapSetHandler(), await this.loadRankMapDetailsHandler()])
      .then(() => {
        this.loading = false;
      })
      .catch((err) => {
        this.isErr = true;
        this.errMsg = err;
      });
  },
};
</script>